import {useEffect} from 'react';

import {
  Conversation,
  InlineDataAction,
} from '@stripe-internal/conversations-client';
import {useInlineDataEvents} from '@stripe-internal/inline-data';

import {buildUHConversationIssueContext} from '../lib/util/conversationUtils';

export function useConversationInlineDataEvents(
  conversation?: Conversation | null,
) {
  const inlineDataEvents = useInlineDataEvents();
  useEffect(() => {
    if (!conversation) {
      return;
    }

    const sub = inlineDataEvents.observable.subscribe((event) => {
      if (event.name === 'inline-data-action') {
        conversation.action(event as InlineDataAction).then((resp) => {
          inlineDataEvents.emit({
            name: 'inline-data-action-result',
            data: event.data,
            nonce: event.nonce,
            code: resp.code,
            error: resp.error,
          });
        });
      }

      if (event.name === 'inline-data-channel-form-initial-message') {
        inlineDataEvents.emit({
          name: 'inline-data-channel-form-initial-message-result',
          data: {
            initialMessage: conversation.context.latestQuestion || '',
          },
          nonce: event.nonce,
        });
      }

      if (event.name === 'inline-data-trigger-scroll-to-top') {
        conversation.triggerScrollToTop();
      }
      if (event.name === 'inline-data-channel-form-issue-context') {
        inlineDataEvents.emit({
          name: 'inline-data-channel-form-issue-context-result',
          data: {
            issueContext: buildUHConversationIssueContext(conversation),
          },
          nonce: event.nonce,
        });
      }
    });
    return () => sub.unsubscribe();
  }, [conversation, inlineDataEvents]);
}
